import styled from 'styled-components'

import { Add as AddSvg } from 'media/icons'

const Add = styled(AddSvg)`
	:hover {
		cursor: pointer;
	}
`

export default Add
